import React from "react";
import { Box, Button, Tooltip } from "@chakra-ui/react";

const TOUR_MODE_TOOLTIP = "Disabled in Tour Mode";

const TourModeActionButton = ({
  children,
  isTour = false,
  isDisabled = false,
  tooltipLabel = TOUR_MODE_TOOLTIP,
  ...props
}) => {
  const disabled = isTour || isDisabled;

  const button = (
    <Button {...props} isDisabled={disabled}>
      {children}
    </Button>
  );

  if (!isTour) {
    return button;
  }

  return (
    <Tooltip label={tooltipLabel} hasArrow>
      <Box as="span" display="inline-block">
        {button}
      </Box>
    </Tooltip>
  );
};

export default TourModeActionButton;
